import { render, staticRenderFns } from "./RegionCountriesList.vue?vue&type=template&id=43ae1274"
import script from "./RegionCountriesList.vue?vue&type=script&lang=js"
export * from "./RegionCountriesList.vue?vue&type=script&lang=js"
import style0 from "./RegionCountriesList.vue?vue&type=style&index=0&id=43ae1274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports